(function () {
  'use strict';

  // Component used for booking item and booking item service item

  angular.module('app').component('pendingBookingItem', pendingBookingItem());

  function pendingBookingItem() {
    return {
      bindings: {
        notification: '<',
        bookingItem: '<',
        bookingItemServiceItem: '<',
        companyId: '<',
        onBookingItemNotificationPending: '&',
      },
      controller: PendingBookingItemComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/bookings/booking-items/booking-item-notification/pending-notification/' +
        'pending-booking-item.component.html',
    };
  }

  PendingBookingItemComponent.$inject = ['UtilService', 'BookingItemNotificationService'];

  function PendingBookingItemComponent(UtilService, BookingItemNotificationService) {
    let vm = this;

    vm.UtilService = new UtilService(vm);

    // Methods
    vm.setBookingItemToPending = setBookingItemToPending;

    vm.$onInit = function () {
      if (!vm.notification) {
        // New
        vm.notification = {};
      }

      vm.notification.observations = '';
    };

    function setBookingItemToPending(isFormValid) {
      vm.formErrors = false;

      if (!isFormValid) {
        vm.formErrors = true;
        return;
      }

      vm.notification.status = 'pending';

      let params = {
        company_id: vm.companyId,
      };

      let bookingItemServiceItemId = vm.bookingItemServiceItem
        ? vm.bookingItemServiceItem.id
        : null;

      vm.sendingForm = true;
      BookingItemNotificationService.saveBookingItemNotification(
        vm.bookingItem.booking_id,
        vm.bookingItem.id,
        bookingItemServiceItemId,
        vm.notification,
        params,
        {}
      ).then(function (response) {
        response = response.data;

        if (!response.errors) {
          let data = {
            notification: response.notification, // null; // as it was deleted on the API response.data
            booking_item_status: response.booking_item_status,
            booking_status: response.booking_status,
            booking_item_service_item_status: null,
          };

          if (vm.bookingItemServiceItem) {
            data.booking_item_service_item_status = response.booking_item_service_item_status;
          }

          vm.onBookingItemNotificationPending({ dataObj: data });

          vm.sendingForm = false;
        }
      });
    }
  }
})();
